export interface NavItem {
  className?: string;
  icon?: React.ReactNode;
  title: string;
  to: string;
}

export const solutions: NavItem[] = [
  {
    title: "Retain",
    to: "/solutions/retain/",
  },
  {
    title: "Convert",
    to: "/solutions/convert/",
  },
  {
    title: "Reactivate",
    to: "/solutions/reactivate/",
  },
  {
    title: "Customer Portal",
    to: "/solutions/customer-portal/",
  },
];

export const forTeams: NavItem[] = [
  {
    title: "CEOs/Founders",
    to: "/teams/ceos-founders/",
  },
  {
    title: "Customer Success",
    to: "/teams/customer-success/",
  },
  {
    title: "Growth Marketing",
    to: "/teams/growth-marketing/",
  },
  {
    title: "Product",
    to: "/teams/product/",
  },
];

export const forIndustries: NavItem[] = [
  {
    title: "SaaS",
    to: "/industries/saas/",
  },
  {
    title: "Ecommerce",
    to: "/industries/ecommerce/",
  },
  {
    title: "Digital Media",
    to: "/industries/digital-media/",
  },
];

export const features: NavItem[] = [
  {
    title: "Easy Setup",
    to: "/features/easy-setup/",
  },
  {
    title: "Custom Branding",
    to: "/features/custom-branding/",
  },
  {
    title: "Exit Surveys",
    to: "/features/customer-exit-surveys/",
  },
  {
    title: "Offers & Deflections",
    to: "/features/offers-and-deflections/",
  },
  {
    title: "Customer Segmentation",
    to: "/features/customer-segmentation/",
  },
  {
    title: "A/B Testing",
    to: "/features/ab-testing/",
  },
  {
    title: "Autopilot Offers",
    to: "/features/autopilot-offers/",
  },
];
